import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";

const TYPE_LABELS = {
  track: "Track",
  module: "Module",
  section: "Section",
  quiz: "Quiz",
  swipe_deck: "Swipe Deck",
  form: "Form",
  roleplay: "Practice Scenario",
};

function UnassignTrackFromEmployeeModal(props) {
  const typeLabel = TYPE_LABELS[props.currentTrack?.assignment_type] || "Item";

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    maxHeight: 400,
    bgcolor: "background.paper",
    border: "2px solid #E2E8F0",
    borderRadius: "15px",
    boxShadow: 24,
    p: 4,
    overflowY: "auto",
  };

  console.log("CURRENT TRACK", props.currentTrack)
  console.log("SELECTED EMPLOYEE", props.selectedEmployee)


  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="unassign-modal-title"
      aria-describedby="unassign-modal-description"
    >
      <Box sx={style}>
        <div
          className="absolute right-2 top-2 text-gray-500 cursor-pointer"
          onClick={props.handleClose}
        >
          <CloseIcon />
        </div>
        <div>
          <div className="flex items-center space-x-3">
            <div className="text-amber-500">
              <WarningIcon style={{ fontSize: "28px" }} />
            </div>
            <div>
              <h3 className="text-2xl text-slate-900">
                Unassign {typeLabel}
              </h3>
            </div>
          </div>
          <div>
            <p className="text-slate-500 text-sm mt-4">
              Are you sure you want to unassign this from {props.selectedEmployee?.first_name}{" "}
              {props.selectedEmployee?.last_name}?
            </p>
          </div>
          <div className="mt-3">
            {props.currentTrack && (
              <div className="p-4 bg-slate-50 rounded-lg border border-slate-200 mt-2">
                <p className="text-sm font-medium text-slate-700 mb-2">{typeLabel} you are unassigning:</p>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-violet-600 rounded-full"></div>
                  <span>{props.currentTrack.name}</span>
                </div>
              </div>
            )}
          </div>
          <div className="w-full flex justify-end mt-8">
            <div className="flex space-x-3">
              <div
                className="px-8 py-2 bg-white border border-slate-300 text-slate-700 hover:bg-slate-100 rounded-xl text-base w-fit cursor-pointer"
                onClick={props.handleClose}
              >
                Cancel
              </div>
              <div
                className="px-8 py-2 bg-red-600 hover:bg-red-700 text-white rounded-xl text-base w-fit cursor-pointer"
                onClick={() => {
                  if (props.currentTrack) {
                    props.post_learning_track_unenrollment(
                      props.currentTrack.uuid,
                      props.selectedEmployee?.id
                    );
                  }
                  props.handleClose();
                }}
              >
                Unassign {typeLabel}
              </div>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default UnassignTrackFromEmployeeModal;
